/**
 * @desc api接口封装
 * @author dhx
 * @time 2024.1.20
 */

import request from "@/utils/request";

const staticList = [
  // 作用 | 名称 | 地址
  ["getReportByKey"     /** 获取新颜 或 祖先知 的报告 */, "/shop/zuxz.zuxz/zuxz",                 "_post" ],
  ["getCashDetail"      /** 获取新颜 或 祖先知 的报告 */, "/shop/cash.cash/detail",               "_post" ],
  ["aliPayBill"         /** 获取支付宝对账单下载地址 */ , "/shop/order.order/aliPayBill",         "_post" ],
  ["create_zfb_QRCode"  /** 获取支付宝跳转二维码 */     , "/shop/product.product/createQrcode",   "_get"  ],
  ["create_wx_QRCode"   /** 获取微信跳转二维码 */       , "/shop/product.product/wxQrcode",       "_get"  ],
  ["create_h5_QRCode"   /** 获取微信跳转二维码 */       , "/shop/product.product/h5Qrcode",       "_get"  ],

  ["get_zfb_config"     /** 获取支付宝配置信息 */       , "shop/appsetting.app/zhifbconfig",      "_get"  ],
  ["update_zfb_config"  /** 修改支付宝配置信息 */       , "shop/appsetting.app/zhifbconfig",      "_post" ],

  ["clearShopDetail"    /** 清理shop端信息 */           , "shop/setting.clear/delectshop",        "_post" ],
  ["orderRefund"        /** 订单退款 */                 , "shop/order.order/billOrderRefund",     "_post" ],
  ["editIssue"          /** 修改首期金额 */             , "shop/order.order/auto_price",          "_post" ],
  ["queryRiskControl"   /** 查询蚂蚁链风遁 */           , "shop/order.Spring/query",              "_post" ],
  ["getRiskNotice"   /** 获取风控预警设置 */            , "shop/setting.cash/riskNotice",          "_get" ],
  ["setRiskNotice"   /** 保存风控预警配置 */            , "shop/setting.cash/riskNotice",          "_post" ],


  [/**"生成蚂蚁链签署合同" */         "createContract",        "/shop/order.orderchain/index",                       "_post"],
  [/**"生成蚂蚁链代扣签约链接" */     "createHoldSign",        "/shop/order.orderchain/createHoldSign",              "_post"],
  [/**"取消代扣计划" */              "cancelWithholdPlan",    "/shop/order.orderchain/cancelWithholdPlan",          "_post"],
  [/**"关闭订单" */                  "closeOrder",            "/shop/order.orderchain/closeOrder",                  "_post"],
  [/**"分期还款" */                  "repayWithholdPlan",     "/shop/order.orderchain/repayWithholdPlan",           "_post"],
  [/**"蚂蚁链查询" */                "getUserTradeInfo",     "/shop/order.Orderchain/getUserTradeInfo",             "_post"],
  [/**"主动发起代扣" */              "createActivePay",       "/shop/order.Orderchain/createActivePay",             "_post"],
];

const orderApiList = [
  ["machineReview"      /** 机器审核 */                ,"/shop/order.Operate/authcheck",        "_post" ],
]

const collectionList = [
  // 接口名称 | 地址 | 接口类型
  ["getCollectionCaseList" /** 获取催收列表 */          , "/shop/collection.index/index",     "_get"],
  ["getCollectionUserList" /** 获取催收人员列表 */          , "/shop/collection.index/getUser",     "_get"],
  ["getCollectionChangeList" /** 待分配案件列表 */          , "/shop/collection.index/orderList",     "_get"],
  ["getCollectionBindAuthUser" /** 绑定催收员 */          , "/shop/collection.index/bindAuthUser",     "_post"],
  ["getCollectionGetList" /** 催收案件列表 */          , "/shop/collection.index/getList",     "_get"],
  ["getCollectionDetail" /** 催收案件详情 */          , "/shop/collection.index/detail",     "_post"],

];

const creditApiList = [
  // 接口名称 | 地址 | 接口类型
  [/**"查询征信"*/                  "queryCredit",            "/shop/xiongyi.index/queryCreate",       "_post"],
  [/**"获取查询结果"*/               "queryResult",            "/shop/xiongyi.index/queryResult",       "_post"],
  [/**"开户"*/                      "creditLoan",             "/shop/xiongyi.index/loan",              "_post"],
  [/**"还款"*/                      "creditRepay",            "/shop/xiongyi.index/creditRepay",       "_post"],
  [/**"结清"*/                      "creditSettle",           "/shop/xiongyi.index/creditSettle",      "_post"],
  [/**"征信报告用户列表"*/           "queryCreditUserList",    "/shop/xiongyi.create/index",            "_post"],
  [/**"征信报告用户详情"*/           "queryCreditUserDetail",  "/shop/xiongyi.create/detail",           "_get"],
  [/**"已开户用户列表"*/             "accountOpenUserList",    "/shop/xiongyi.person/index",            "_post"],
  [/**"已开户用户详情"*/             "accountOpenUserDetail",  "/shop/xiongyi.person/detail",           "_get"],
  [/**"已开户用户还款分期列表"*/      "openedUserRepaymentFin", "/shop/xiongyi.person/repayList",        "_get"],
  [/**"获取图片base64"*/            "fileToBase64",           "/shop/xiongyi.index/fileToBase64",      "_post"],
  [/**"生成e签宝静默签"*/            "geteSign",               "/shop/order.silentsignature/index",    "_post"],
];

const api = {};

export function ApiInterface(api, list) {
  if (
    typeof api !== "object" ||
    list instanceof Array === false ||
    list.length === 0
  )
    throw new Error("参数错误");

  // 添加接口
  function add(key, url, reqType = "_get") {
    api[key] = function(params, errorBack = true) {
      return request[reqType](url, params, errorBack);
    };
  }

  // 删除接口
  function del(key) {
    delete api[key];
  }

  function init() {
    list.forEach(item => add(item[0], item[1], item[2])); // 初始化接口列表
    return handler;
  }

  const handler = { add, del, api, init };

  return handler;
}

ApiInterface(api, [
  ...staticList, ...collectionList,
  ...creditApiList, ...orderApiList
]).init(); // 初始化接口

export default () => api;



// WEBPACK FOOTER //
// ./src/api/useApi.js